export function selectWhere(data, propertyKey, propertyName) {
    //return the first elelment in the data that has both the supplied key and the supplied value for that key (the property name)
    //
    // console.log("data", data);
    // console.log(" propertyKey ", propertyKey);
    // console.log(" propertyName", propertyName);
    // console.log("data.length = ", data.length);
    if (data.length != undefined) {
        for (var i = 0; i < data.length; i++) {
            // console.log("data[i]", data[i])
            if (data[i][propertyKey] !== null) {
                if (data[i][propertyKey] == propertyName) {
                    return data[i];
                    // console.log("data[i]", data[i])
                }
            }
        }
    } else {
        if (data[propertyKey] !== null) {
            if (data[propertyKey] == propertyName) {
                return data;
                // console.log("data[i]", data[i])
            }
        }
    }
    return null;
}

export function selectWhereKey(data, propertyKey) {
    //return one the first element in the dat athat has the supplied key
    //
    // console.log("data ", data);
    // console.log(" propertyKey ", propertyKey);
    // console.log(" propertyName", propertyName);
    // console.log("data.length = ", data.length);
    if (data.length != undefined) {
        for (var i = 0; i < data.length; i++) {
            // console.log("data[i]", data[i])
            if (data[i][propertyKey] !== null) {
                // if (data[i][propertyKey] == propertyName) {
                return data[i][propertyKey];
                // console.log("data[i]", data[i])
            }
            // }
        }
    } else {
        if (data[propertyKey] !== null) {
            // if (data[propertyKey] == propertyName) {
            return data[propertyKey];
            // console.log("data[i]", data[i])
            // }
        }
    }
    return null;
}
//


export function selectEach(data, propertyKey, propertyName) {
    // return all elements from the data that match the pattern
    //
    // console.log("data", data);
    // console.log(" propertyKey ", propertyKey);
    // console.log(" propertyName", propertyName);
    // console.log("data.length = ", data.length);
    let allElements = [];
    if (data.length != undefined) {
        for (var i = 0; i < data.length; i++) {
            // console.log("data[i]", data[i])
            if (data[i][propertyKey] !== null) {
                if (data[i][propertyKey] == propertyName) {
                    allElements.push(data[i]);
                    //return data[i];
                    // console.log("data[i]", data[i])
                }
            }
        }
        // console.log("allElements: pre sort ", allElements);
        sortOnKey(allElements, "updated_at");
        // console.log("allElements: post sort ", allElements);
        return allElements;

    } else {
        if (data[propertyKey] !== null) {
            if (data[propertyKey] == propertyName) {
                return data;
                // console.log("data[i]", data[i])
            }
        }
    }
    return null;
}

export function sortOnKey(arr, key) {
    //returns an array sorted from highest to lowest based on the key
    arr.sort(function(a, b) {
        // var keyA = new Date(a.updated_at),
        //     keyB = new Date(b.updated_at);
        var keyA = new Date(a[key]),
            keyB = new Date(b[key]);
        // Compare the 2 dates
        if (keyA > keyB) return -1;
        if (keyA < keyB) return 1;
        return 0;
    })
}